@if (video) {
<div class="video-setting-view">
  <mat-icon class="onsip-video-enabled-color">check</mat-icon>
  <div class="mat-body-1">{{ "ONSIP_I18N.ENABLED_REPS_WILL_RECEIVE_VIDEO_CALLS" | translate }}</div>
</div>
} @if (!video) {
<div class="video-setting-view">
  <mat-icon class="onsip-video-disabled-color">close</mat-icon>
  <div class="mat-body-1">
    {{ "ONSIP_I18N.DISABLED_REPS_WILL_NOT_RECEIVE_VIDEO_CALLS" | translate }}
  </div>
</div>
}
